<template>
    <Fragment>
        <a class="button" v-if="!filter.records" @click="toggleRecords">Fangster</a>
        <a class="button" v-if="filter.records" @click="toggleRecords">Rekorder</a>
        <!-- <a v-if="filter.species">{{filter.species.name}}</a>
            <a v-if="filter.catcher">{{filter.catcher.name}}</a>
        <a v-if="filter.region">{{filter.region.name}}</a>-->
    </Fragment>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { Fragment } from 'vue-fragment';

export default {
    components: { Fragment },
    computed: {
        ...mapState('catches', ['filter']),
    },
    methods: {
        ...mapActions('catches', ['loadCatchesFromFilter']),
        toggleRecords() {
            this.loadCatchesFromFilter({
                records: !this.filter.records, region: this.filter.region, catcher: this.filter.catcher, species: this.filter.species,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
nav {
    justify-content: floor;
    flex: 1;
    flex-direction: row;
}
</style>
